<div fxFlexFill class="container">

    <mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="start center" class="mat-elevation-z1 main-navbar"
        fxLayoutGap="10px">
        <button mat-icon-button routerLink="/" type="button">
            <mat-icon svgIcon="arrow-left"></mat-icon>
        </button>
        <span>
            {{ 'PP' | translate }}
        </span>
    </mat-toolbar>

    <mat-card fxLayout="column" class="floating card">

        <div fxFlex="10" fxLayout="column" fxLayoutAlign="center center">
            <span escCustomId="subtitle,txt,esc_privacy_policy" class="subtitle">{{'POLICY_APP_NAME'|translate}}</span>
        </div>

        <div fxFlex="auto" fxLayout="row" class="mat-tab-padding" style="overflow: auto;"
            *ngIf="!loading && !networkError && !loadingError">
            <mat-tab-group mat-stretch-tabs fxFlex>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <span escCustomId="tc_title,txt,esc_privacy_policy">{{'TC'|translate}}</span>
                    </ng-template>

                    <div *ngFor="let item of tcPage; let i = index" class="paragraph">
                        <span
                            [escCustomId]=" item.code + '_sub_title,txt,esc_privacy_policy_' + i">{{item.title}}</span>

                        <ng-container *ngFor="let paragraph of formatParagraph(item.description); let i = index"
                            [escCustomId]=" item.code + '_paragraph,txt,esc_privacy_policy_' + i">
                            <!-- normal paragraph -->
                            <p *ngIf="!isBulletForm(paragraph)"
                                [escCustomId]=" item.code + '_p,txt,esc_privacy_policy_' + i">
                                {{paragraph}}</p>

                            <!-- unordered list/bullet points -->
                            <ng-container *ngIf="isBulletForm(paragraph)">
                                <div class="bullet-form" style="display:block"
                                    [innerHTML]="formatBulletForm(paragraph)">

                                </div>
                            </ng-container>

                        </ng-container>
                    </div>

                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <span escCustomId="pp_title,txt,esc_privacy_policy">{{'PP'|translate}}</span>
                    </ng-template>

                    <div *ngFor="let item of ppPage; let i = index" class="paragraph">
                        <span
                            [escCustomId]=" item.code + '_sub_title,txt,esc_privacy_policy_' + i">{{item.title}}</span>

                        <ng-container *ngFor="let paragraph of formatParagraph(item.description); let i = index"
                            [escCustomId]=" item.code + '_paragraph,txt,esc_privacy_policy_' + i">
                            <!-- normal paragraph -->
                            <p *ngIf="!isBulletForm(paragraph)"
                                [escCustomId]=" item.code + '_p,txt,esc_privacy_policy_' + i">
                                {{paragraph}}</p>

                            <!-- unordered list/bullet points -->
                            <ng-container *ngIf="isBulletForm(paragraph)">
                                <div class="bullet-form" style="display:block"
                                    [innerHTML]="formatBulletForm(paragraph)">

                                </div>
                            </ng-container>

                        </ng-container>

                    </div>

                    <!-- NPC Seal Link -->
                    <div class="paragraph">
                        <span>
                            <a href="https://www.electronicscience.com/dpoqr.html" target="_blank"
                            [escCustomId]=" 'npc_seal' + '_sub_title,txt,esc_privacy_policy_' + i">National Privacy Commission Seal</a>
                        </span>
                    </div>

                </mat-tab>

            </mat-tab-group>
        </div>

        <div escCustomId="loading,div,esc_privacy_policy" fxFlex="auto" fxLayout="column" fxLayoutAlign="center center"
            *ngIf="loading">
            <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
        </div>

        <esc-message-info-overlay fxFlex="auto" escCustomId="net_err,div,esc_privacy_policy"
            *ngIf="networkError && !loading" (btnFn)="getData()"></esc-message-info-overlay>

        <esc-message-info-overlay fxFlex="auto" escCustomId="load_err,div,esc_privacy_policy"
            *ngIf="loadingError && !loading" title="{{'MESSAGE_ERROR_FAILED_TO_LOAD'|translate}}"
            message="Unknown Error. Please try again later." (btnFn)="getData()"></esc-message-info-overlay>

    </mat-card>

</div>